import {SplitBillItemModel} from "./split-bill-item.model";

export class SplitBillModel {
  public orderId: string;
  public itemsInNewOrderBills: Array<Array<SplitBillItemModel>>;

}
